"use strict";

// La hora de envio de un Envio: en punto, 0 a 23, o null para "en la corrida
// diaria", que es lo que pasa cuando no hay hora.

export const hourLabel = hour => `${hour < 10 ? "0" : ""}${hour}:00`;

export const NO_HOUR_OPTION = { value: null, text: "En la corrida diaria" };

export const HOUR_OPTIONS = [NO_HOUR_OPTION].concat(
  Array.from({ length: 24 }, (_, hour) => ({ value: hour, text: hourLabel(hour) }))
);
